import { NgModule } from '@angular/core';
import { InviteDetailsComponent } from './pages/invite-details';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

const PROVIDERS = [];

@NgModule({
  declarations: [
    InviteDetailsComponent,
  ],
  exports: [
    InviteDetailsComponent,
  ],
  providers: [
    PROVIDERS
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class JoinInviteModule { }
